import React, { FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { WithTranslation } from 'react-i18next';
import { TCHHomeProductDashSeriesItem } from '../../../types/productDashboard.types';
import Picture from '../../../../@shared/picture';
import CTA from '../../../../@shared/CTA';
import ctaTypes from '../../../../../enums/CTA.enums';
import { appendRootToRichTextInternalLinks } from '../../../../../utils/appendRootToRichTextInternalLinks.utils';

export type TProductCardProps = {
  data: TCHHomeProductDashSeriesItem;
  cardType: string;
  linkUrl?: string;
  onClick?: () => unknown;
};

const ProductCard: FC<WithTranslation & TProductCardProps> = (props) => {
  const { data, cardType, t, onClick, linkUrl } = props;
  const seriesCardType = cardType === 'series';
  const productDescription = appendRootToRichTextInternalLinks(data?.shortDescription || data?.description);

  return (
    <div className="product-dashboard-card__container">
      <div className="product-dashboard-card__image">
        <Picture
          productImageProps={{
            desktopRendition: data?.assets?.[0]?.rendition_desktop_size500,
            alt: data?.assets?.[0]?.alt,
            imageClassName: 'product-dashboard-card__image--fixed-aspect-ratio',
          }}
        />
      </div>
      <div className="product-dashboard-card__content">
        {data?.title && <h3 className="product-dashboard-card__title">{data?.title}</h3>}
        {productDescription && (
          <RichText field={{ value: productDescription }} editable={false} className="product-dashboard-card__description rich-text" />
        )}
        <div className="product-dashboard-card__link">
          {seriesCardType ? (
            <div onClick={onClick}>
              <CTA type={ctaTypes.primaryOrange} extraClassName="product-dashboard-card__button">{t('cnhi-viewAllModels')}</CTA>
            </div>
          ) : (
            <CTA type={ctaTypes.primaryOrange} href={linkUrl} extraClassName="product-dashboard-card__button">
              {t('cnhi-viewModel')}
            </CTA>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
